var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.5925H19.67L14.79 20.4725C14.4 20.8625 14.4 21.5025 14.79 21.8925C15.18 22.2825 15.81 22.2825 16.2 21.8925L22.79 15.3025C23.18 14.9125 23.18 14.2825 22.79 13.8925L16.21 7.29249C16.0232 7.10523 15.7695 7 15.505 7C15.2405 7 14.9868 7.10523 14.8 7.29249C14.41 7.68249 14.41 8.31249 14.8 8.70249L19.67 13.5925H8.5C7.95 13.5925 7.5 14.0425 7.5 14.5925C7.5 15.1425 7.95 15.5925 8.5 15.5925Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow_forward.304dd4020fd44e885bb9be63b9df74a0.svg";
export { ForwardRef as ReactComponent };